export enum RegistrationReviewStates {
  Initial = 'initial',
  Pending = 'pending',
  Accepted = 'accepted',
  Rejected = 'rejected',
  Withdrawn = 'withdrawn',
  Embargo = 'embargo',
  PendingEmbargoTermination = 'pending_embargo_termination',
  PendingWithdrawRequest = 'pending_withdraw_request',
  PendingWithdraw = 'pending_withdraw',
}
